import marketTradeSubscriptionService from '../../services/subscriptions/marketTradeSubscriptionService';
import { showSnack } from './snackbarActions';
export var initMarketTradeSubscription = function initMarketTradeSubscription() {
  return function (dispatch) {
    marketTradeSubscriptionService.initSubscribtion();
  };
};

// Responsible for showing snackbar messages if instrument paused/resumed/halted/started
export var subscribeToMarketTradeUpdated = function subscribeToMarketTradeUpdated() {
  return function (dispatch, getState) {
    // Actually instrumentReducer already store SessionStatus of instrument which should be source of truth BUT
    // for some reason after capturing event that Instrument is paused server still returns this Instrument with
    // previous status. Looks like server sends an event while pausing/resuming is in progress.
    // This is why we store local copy of statuses here, another case is that server sends ~50 same events if SessionStatus
    // is changed, but we don't want to show 50 snackbars.
    var instruments = getState().apexCore.instrument.instruments.map(function (instrument) {
      return {
        InstrumentId: instrument.InstrumentId,
        Symbol: instrument.Symbol,
        SessionStatus: instrument.SessionStatus
      };
    });
    marketTradeSubscriptionService.subscribe(function (updates) {
      instruments.map(function (instrument) {
        if (instrument.InstrumentId === updates.VenueInstrumentId && instrument.SessionStatus !== updates.NewStatus) {
          instrument.SessionStatus = updates.NewStatus;
          var snackBar = getMarketUpdateSnackbar(instrument, updates);
          dispatch(showSnack({
            id: snackBar.id,
            text: snackBar.text,
            type: snackBar.type
          }));
        }
        return instrument;
      });
    });
  };
};
var getMarketUpdateSnackbar = function getMarketUpdateSnackbar(instument, update) {
  var id = 'OrderStateEventSnackbar-' + update.VenueInstrumentId + '-' + update.NewStatus;
  var type = 'info';
  var text = 'Market for ' + instument.Symbol + ' is ' + update.NewStatus;
  return {
    id: id,
    type: type,
    text: text
  };
};